function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Input, Form, Button, Select, Alert, Space, Spin, Modal, Descriptions, message } from 'antd';
import axios from 'axios';
import Common from "../includes/Common";
import { ExclamationCircleFill } from 'react-bootstrap-icons';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var confirm = Modal.confirm;
var Option = Select.Option;
var NewCustomer = function NewCustomer(_ref) {
  var _ref$handleUpdate = _ref.handleUpdate,
    handleUpdate = _ref$handleUpdate === void 0 ? null : _ref$handleUpdate;
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFormLoading = _useState2[0],
    setIsFormLoading = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    errorMessage = _useState4[0],
    setErrorMessage = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    successMessage = _useState6[0],
    setSuccessMessage = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    createdValues = _useState8[0],
    setCreatedValues = _useState8[1];
  var _useState9 = useState([]),
    _useState0 = _slicedToArray(_useState9, 2),
    pmOptions = _useState0[0],
    setPmOptions = _useState0[1];
  var today = new Date();
  var date = today.getDate() + '/' + (today.getMonth() + 1) + '/' + today.getFullYear();
  function printR() {
    var content = document.getElementById("prtdiv");
    var pri = document.getElementById("ifmcontentstoprint").contentWindow;
    pri.document.open();
    pri.document.write(content.innerHTML);
    pri.document.close();
    pri.focus();
    pri.print();
  }
  var enroll = function enroll(values) {
    setIsFormLoading(true);
    var formData = new FormData();
    formData.append('firstname', values.firstname);
    formData.append('lastname', values.lastname);
    formData.append('amount', '120000');
    formData.append('paymentmethod', values.paymentmethod);
    formData.append('mobile', values.mobile);
    formData.append('rnc', values.rnc);
    axios.post(Common.baseApiUrl + 'addcustomer/' + Common.currentUser.id.toString(), formData).then(function (response) {
      setIsFormLoading(false);
      if (response.data.status == 200) {
        setSuccessMessage(response.data.message);
        handleUpdate();
        setCreatedValues(response.data.customer);
        form.setFieldsValue({
          firstname: '',
          lastname: '',
          rnc: '',
          mobile: '',
          paymentmethod: 1
        });
        printR();
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      setIsFormLoading(false);
      setErrorMessage('Une erreur est survenue');
    });
  };
  useEffect(function () {
    form.setFieldsValue({
      paymentmethod: '1'
    });
    axios.get(Common.baseApiUrl + 'getactivepaymenttypes/' + Common.currentUser.id).then(function (response) {
      if (response.data.status == 200) {
        response.data.paymentTypes.forEach(function (p) {
          setPmOptions(function (old) {
            return [].concat(_toConsumableArray(old), [{
              label: p.label,
              value: p.id
            }]);
          });
          form.setFieldsValue({
            paymentmethod: 1
          });
        });
      }
    })["catch"](function (error) {
      message.error({
        content: "Une erreur est survenue, contactez l'administrateur",
        delay: 4
      });
    });
  }, []);
  var onFinish = function onFinish(values) {
    setErrorMessage('');
    setSuccessMessage('');
    confirm({
      title: 'Confirmez-vous ?',
      icon: /*#__PURE__*/_jsx(ExclamationCircleFill, {}),
      content: 'La creation du client #RNC -' + values.rnc + '# et encaissement de 200 000 GNF reçu par ' + values.paymentmethod + '?',
      onOk: function onOk() {
        enroll(values);
      },
      onCancel: function onCancel() {
        console.log('Cancel');
      }
    });
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [errorMessage.length != 0 && /*#__PURE__*/_jsx(Alert, {
      message: errorMessage,
      type: "error",
      showIcon: true
    }), successMessage.length != 0 && /*#__PURE__*/_jsx(Alert, {
      message: successMessage,
      type: "success",
      showIcon: true
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), createdValues != null && /*#__PURE__*/_jsxs("div", {
      style: {
        textAlign: 'center'
      },
      id: "prtdiv",
      children: [/*#__PURE__*/_jsx("div", {
        style: {
          width: '70px'
        },
        children: /*#__PURE__*/_jsx("img", {
          src: "drawables/mvc.jpeg",
          style: {
            width: '100%'
          }
        })
      }), /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsxs("h1", {
          style: {
            textAlign: "center",
            fontSize: "50px",
            fontWeight: "bold"
          },
          children: ["#", createdValues.rank]
        })
      }), /*#__PURE__*/_jsxs("h2", {
        children: ["RNC : ", createdValues.rnc]
      }), /*#__PURE__*/_jsxs(Descriptions, {
        column: 1,
        children: [/*#__PURE__*/_jsx(Descriptions.Item, {
          label: "T\xE9l\xE9phone : ",
          children: createdValues.mobile
        }), /*#__PURE__*/_jsx(Descriptions.Item, {
          label: "Nom :",
          children: createdValues.firstname + ' ' + createdValues.lastname
        }), /*#__PURE__*/_jsx(Descriptions.Item, {
          label: "Montant : ",
          children: "120 000 GNF"
        }), /*#__PURE__*/_jsx(Descriptions.Item, {
          label: "M. Paiement : ",
          children: createdValues.paymentmethod
        })]
      }), /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx("b", {
          children: "Adresse: CEPERTAM, Conakry, R\xE9publique de Guin\xE9e. Tel: 611 72 49 21"
        })
      })]
    }), /*#__PURE__*/_jsx("iframe", {
      id: "ifmcontentstoprint",
      style: {
        height: '0px',
        width: '0px',
        position: 'absolute'
      }
    }), /*#__PURE__*/_jsxs(Form, {
      layout: "vertical",
      onFinish: onFinish,
      form: form,
      children: [/*#__PURE__*/_jsx(Form.Item, {
        name: "rnc",
        label: "RNC",
        rules: [{
          required: true,
          message: 'Ce champs est obligatoire'
        }],
        children: /*#__PURE__*/_jsx(Input, {})
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "firstname",
        label: "Pr\xE9nom",
        rules: [{
          required: true,
          message: 'Ce champs est obligatoire'
        }],
        children: /*#__PURE__*/_jsx(Input, {})
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "lastname",
        label: "Nom",
        rules: [{
          required: true,
          message: 'Ce champs est obligatoire'
        }],
        children: /*#__PURE__*/_jsx(Input, {})
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "mobile",
        label: "T\xE9l\xE9phone",
        rules: [{
          required: true,
          message: 'Ce champs est obligatoire'
        }],
        children: /*#__PURE__*/_jsx(Input, {})
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "paymentmethod",
        label: "Moyen de paiement",
        rules: [{
          required: true,
          message: 'Choisir le moyen de paiement'
        }],
        children: /*#__PURE__*/_jsx(Select, {
          showSearch: true,
          defaultValue: 1,
          options: pmOptions
        })
      }), /*#__PURE__*/_jsxs(Space, {
        direction: "horizontal",
        children: [/*#__PURE__*/_jsx(Form.Item, {
          name: "submit",
          children: /*#__PURE__*/_jsx(Button, {
            disabled: pmOptions.length == 0,
            htmlType: "submit",
            type: "default",
            children: "Enroller"
          })
        }), isFormLoading && /*#__PURE__*/_jsx(Spin, {})]
      })]
    })]
  });
};
export default NewCustomer;